// extracted by mini-css-extract-plugin
export default {"List":"TodoItemEPC_List__ekccA","Link":"TodoItemEPC_Link__VBZjq"};